import React, { useEffect, useState } from 'react';
import axios from 'axios';
import CountUp from 'react-countup';

const ChiffresCles = () => {
  const [chiffres, setChiffres] = useState([]);
  const Url = process.env.REACT_APP_URL_DEV;
  const publicUrl = process.env.PUBLIC_URL + '/';

  useEffect(() => {
    axios
      .get(`${Url}/api/ChiffreCle/all`)
      .then((response) => {
        setChiffres(response.data.data);
      })
      .catch((error) => {
        console.error('Erreur lors du chargement des chiffres clés :', error);
      });
  }, []);

  return (
    <div
      style={{
        backgroundImage: `url(${publicUrl}assets/img/banner/background.webp)`,
        backgroundSize: 'cover',
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'center',
        padding: '30px 0',
        minHeight: '150px',
        opacity: '0.8',
      }}
    >
      <div className="container">
        <div className="title text-center mb-5">
          <h1 style={{ color: 'black', fontWeight: '600' }}>
            <b>Chiffres clés</b>
          </h1>
        </div>

        <div className="row text-center">
          {chiffres.map((item, index) => (
            <div key={index} className="col-lg-3 col-md-6 col-sm-12 mb-4">
              <div className="single-intro-inner style-icon-bg bg-gray p-4">
                <div className="thumb">
                  <img
                    src={`${Url}/images/${item.Icone}`}
                    alt={item.Titre}
                    style={{ maxWidth: '80px' }}
                  />
                </div>
                <div className="details">
                  <h5>
                    <CountUp
                      start={0}
                      end={item.Valeur}
                      duration={5}
                      separator=" "
                      prefix={index === 2 ? '' : '+'}
                      suffix={index === 2 ? '%' : ''}
                    />
                  </h5>

                  <p>{item.Titre}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ChiffresCles;
